import { SaleDepartmentEnum } from 'common/constants/enum';
import { Translate } from 'next-translate';

const saleDepartmentOptions = (t: Translate) => [
  {
    id: SaleDepartmentEnum.Flight,
    label: t('common:flight'),
  },
  {
    id: SaleDepartmentEnum.Hotel,
    label: t('common:hotel'),
  },
  {
    id: SaleDepartmentEnum.Cruise,
    label: t('common:cruise'),
  },
  {
    id: SaleDepartmentEnum.Document,
    label: t('common:travel_document'),
  },
  {
    id: SaleDepartmentEnum.Activity,
    label: t('common:activity'),
  },
  {
    id: SaleDepartmentEnum.Product,
    label: t('common:product'),
  },
];

export default saleDepartmentOptions;
